import React from 'react'
import './Field.css'

const Field = props => {
  const classNames = ['Field']

  if(props.selected) classNames.push('is-selected')

  return (
    <div className={classNames.join(' ')}>
      <label>
        <span className="Field-input"><Input {...props} /></span>
        <span className="Field-label">{props.label}</span>
      </label>
    </div>
  )
}

const Input = props => (
  <div className={`Input Input-${props.type}`}>
    <input
      type={props.type}
      name={props.name}
      value={props.value}
      onChange={props.onChange} />
  </div>
)

export default Field


// WEBPACK FOOTER //
// ./src/components/library/forms/Field.js